import {
  AddCustomerRequest,
  UpdateCustomerRequest,
  UpdateCustomerStatusRequest,
} from '../../interface/request/CustomerRequest'
import { GenericAPIResponse } from '../../interface/response/CommonResponse'
import {
  CustomerDetailData,
  CustomersData,
} from '../../interface/response/CustomerResponse'
import { apiService } from '../apiService'

export const customerApiService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getCustomers: builder.query({
      query: (args: object) => {
        return {
          url: `/Customer/GetCustomers`,
          params: args,
        }
      },
      transformResponse: (response: { data: CustomersData[] }) => {
        return response?.data
      },
      providesTags: ['CustomerList'],
    }),
    getCustomersDetailsByCode: builder.query({
      query: (customerCode: string) => {
        return {
          url: `/Customer/GetCustomersDetailsByCode`,
          params: {
            customerCode: customerCode,
          },
        }
      },
      transformResponse: (response: { data: CustomerDetailData }) => {
        return response?.data
      },
      providesTags: ['GetCustomerByCode'],
    }),
    addCustomer: builder.mutation({
      query: (queryData: AddCustomerRequest) => {
        return {
          url: `/Customer/AddCustomer`,
          method: 'POST',
          body: queryData,
        }
      },
      invalidatesTags: ['CustomerList'],
      transformResponse: (response: GenericAPIResponse) => {
        return response
      },
    }),
    updateCustomer: builder.mutation({
      query: (queryData: UpdateCustomerRequest) => {
        return {
          url: `/Customer/UpdateCustomer`,
          method: 'POST',
          body: queryData,
        }
      },
      invalidatesTags: ['CustomerList', 'GetCustomerByCode'],
      transformResponse: (response: GenericAPIResponse) => {
        return response
      },
    }),
    updateCustomerStatus: builder.mutation({
      query: (queryData: UpdateCustomerStatusRequest) => {
        return {
          url: `/Customer/UpdateCustomerStatus`,
          method: 'POST',
          body: queryData,
        }
      },
      invalidatesTags: ['CustomerList', 'GetCustomerByCode'],
      transformResponse: (response: GenericAPIResponse) => {
        return response
      },
    }),
  }),
})

export const {
  useLazyGetCustomersQuery,
  useLazyGetCustomersDetailsByCodeQuery,
  useAddCustomerMutation,
  useUpdateCustomerMutation,
  useUpdateCustomerStatusMutation,
} = customerApiService
